import PropTypes from 'prop-types';
import React from 'react';

// styles
import css from './checkbox.sss';


export const Checkbox = (props) => (
    <label className={css.root}>
        <input
            type='checkbox'
            name={props.name}
            className={css.input}
            checked={props.checked}
            disabled={props.disabled}
            data-qa={props.dataQa}
            onChange={props.disabled ? null : props.onChange}
        />
        <span className={css.fakeInput} />
        <span className={css.text}>
            {props.children}
        </span>
    </label>
);

Checkbox.propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    dataQa: PropTypes.string,
};
